module.exports = __webpack_public_path__ + "static/media/a95297b322004db9.b44e31e4.svg";